import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StepsShared } from '../../../models/interface/steps.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mu-steps-breadcrumb',
  templateUrl: './mu-steps-breadcrumb.component.html',
  styleUrls: ['./mu-steps-breadcrumb.component.sass'],
})
export class MuStepsBreadcrumbComponent implements OnInit, OnChanges {
  @Input() itemList: StepsShared[] = [];
  @Input() activeIndex: number;
  @Input() readonly: boolean;
  @Input() hideNumber: boolean;
  @Input() defaultUrl: string = '';
  @Output() isLoadedBreadcrumb = new EventEmitter();

  constructor(private translateService: TranslateService, private router: Router) {
    /** */
  }

// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.itemList) {
        this.itemList = this.itemList.map(x => {
          if (x.url !== undefined && x.url !== null) {
            return {
              label: this.translateService.instant(x.label),
              command: () => this.navigateStep(x.url),
              disabled: x.disabled,
              styleClass: x?.styleClass || '',
            };
          }
          return x;
        });
        this.itemList = [...this.itemList];
        this.isLoadedBreadcrumb.emit(true);
      }
    }, 500);
    if (this.readonly) {
      return environment.guardClause;
    }
  }

  /**
   * navigate step select
   *
   * @param {string} url
   * @memberof MuStepsBreadcrumbComponent.navigateStep
   */
  navigateStep(url: string): void {
    this.router.navigate([url ? url : this.defaultUrl]);
  }
}
